import styled from '@emotion/styled';

interface ButtonProps {
  activated?: boolean;
}

export const SpinnerWrapper = styled.div`
  height: 500px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FeatureIcon = styled.div`
  border: 1px solid #989fb2;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  .user-icon {
    width: 15px;
    height: 15px;
  }
`;

export const Media = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const RowP = styled.p`
  padding-left: 15px;
  color: #6c7488;
  line-height: 6px;
`;

export const BlueBtn = styled.button<ButtonProps>`
  padding: 0 20px;
  background-color: var(--lp-colors-medium-blue-800);
  color: #fff;
  border: 1px solid var(--lp-colors-medium-blue-800);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  box-shadow: 0.5px 0.5px 3px 0.6px rgb(220 227 235 / 56%);
  width: auto;
  letter-spacing: 0.35px;
  cursor: pointer;
  font-weight: 400;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  height: 40px;

  &:disabled {
    opacity: 0.5;
  }
  &:first-of-type {
    margin-left: 0;
  }
  ${(props) =>
    props.activated &&
    `
    background-color: lightgrey;
    border-color: grey;
    color: black;
    font-size: 12px;
  `}
`;

export const MerchantBasicInfoTable = styled.div`
  .item-list {
    list-style: none;
    margin: 0;
    line-height: 10px;
    display: flex;
    flex-flow: column nowrap;
    padding: 0;

    .item {
      position: relative;
      display: flex;
      flex-direction: column;
    }

    > li {
      border-top: 1px solid #e6eaee;
      padding: 8px 0;

      &:first-child,
      &:nth-child(2) {
        border: 0;
      }
    }

    .item-row {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: stretch;
      -ms-flex-align: stretch;
      align-items: stretch;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      -ms-flex-direction: row;
      flex-direction: row;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: flex-start;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      min-width: 100%;
      position: relative;
    }

    .item-col {
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: flex-start;
      display: -webkit-box;
      display: -ms-flexbox;
      display: inline-flex;
      text-align: left;
      flex-direction: column;
      gap: 15px;
      padding: 5px 40px 5px 0px;
      -ms-flex-preferred-size: 0;
      -webkit-box-flex: 3;
      -ms-flex-positive: 3;
      -ms-flex-negative: 3;
      flex-shrink: 3;
      margin-right: 0;
      min-width: 0;

      .item-label {
        color: #6c7488;
      }

      .item-value {
        display: flex;
        font-weight: bold;
        height: 20px;
        align-items: center;
      }
    }
  }
`;
